import { Box, Button, CircularProgress, DialogActions, DialogContent, Paper } from '@mui/material'
import * as React from 'react'
import { AttendanceLayoutVariant } from './attendanceLayout'

type AttendanceShellProps = {
	variant: AttendanceLayoutVariant
	children: React.ReactNode
}

export function AttendanceShell({ variant, children }: AttendanceShellProps) {
	if (variant === 'dialog') {
		return <>{children}</>
	}

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
				minHeight: 0,
				overflow: 'hidden',
			}}
		>
			{children}
		</Box>
	)
}

type AttendanceBodyProps = {
	variant: AttendanceLayoutVariant
	children: React.ReactNode
	sx?: Record<string, unknown>
}

export function AttendanceBody({ variant, children, sx }: AttendanceBodyProps) {
	if (variant === 'dialog') {
		return <DialogContent sx={sx}>{children}</DialogContent>
	}

	return (
		<Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', ...sx }}>{children}</Box>
	)
}

type AttendanceActionsProps = {
	variant: AttendanceLayoutVariant
	loading?: boolean
	onCancel: () => void
	onConfirm: () => void
	cancelLabel?: string
	confirmLabel?: string
}

export function AttendanceActions({
	variant,
	loading,
	onCancel,
	onConfirm,
	cancelLabel = 'Cancel',
	confirmLabel = 'Confirm',
}: AttendanceActionsProps) {
	const actions = loading ? (
		<CircularProgress color='success' size={28} />
	) : (
		<>
			{variant === 'dialog' && (
				<Button color='warning' variant='contained' onClick={onCancel}>
					{cancelLabel}
				</Button>
			)}
			<Button color='success' variant='contained' onClick={onConfirm}>
				{confirmLabel}
			</Button>
		</>
	)

	if (variant === 'dialog') {
		return <DialogActions sx={{ justifyContent: 'space-between' }}>{actions}</DialogActions>
	}

	return (
		<Paper
			elevation={0}
			sx={{
				flexShrink: 0,
				borderTop: 1,
				borderColor: 'divider',
				px: 2,
				py: 1.5,
				display: 'flex',
				justifyContent: 'flex-end',
				alignItems: 'center',
				bgcolor: 'background.paper',
			}}
		>
			{actions}
		</Paper>
	)
}
